import React from 'react';
import cx from 'classnames';

export default function ErrorIcon(props: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}) {
  return (
    <svg
      className={cx(props.className, 'icon-error', 'icon')}
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#EB5050"
    >
      <rect width="24" height="24" rx="12" />
      <path
        d="M11.486 14.442H12.548L12.746 6H11.27L11.486 14.442ZM11 18.6H13.034V16.332H11V18.6Z"
        fill="white"
      />
    </svg>
  );
}
